import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import { FormattingPage } from '@/pages/FormattingPage';
import { HomePage } from '@/pages/HomePage';
import '@/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/formatting" element={<FormattingPage />} />
        <Route path="*" element={<Navigate to="/formatting" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
